export default __webpack_public_path__ + "static/media/575.db91f35c.png";